import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';
import { serializeRtkQueryError } from 'util/rtkQueryError';

export const NOTARIES_TAGS = {
  REPOSITORY_USER: 'RepositoryUser'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [NOTARIES_TAGS.REPOSITORY_USER]
});

export const notariesApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listRepositoryUsers: build.query({
      async queryFn(args) {
        const {
          indexStart = 0,
          maxResults = 10,
          search = '',
          sortOrder
        } = args || {};

        const params = {
          indexstart: indexStart,
          maxresults: maxResults,
          ...(search ? { text: search } : {}),
          ...(sortOrder ? { order: sortOrder } : {})
        };

        try {
          const res = await api.RepositoryUsers.listPaged(params);
          return { data: res };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      providesTags: [{ type: NOTARIES_TAGS.REPOSITORY_USER, id: 'LIST' }]
    }),

    getNotaryAuditLog: build.query({
      async queryFn(notaryUserGuid) {
        if (!notaryUserGuid) {
          return { data: [] };
        }
        try {
          const res = await api.RepositoryNotaries.auditLog(notaryUserGuid);
          const items = Array.isArray(res) ? res : res?.Objects || [];
          return { data: items };
        } catch (error) {
          return { error: serializeRtkQueryError(error) };
        }
      },
      keepUnusedDataFor: 60
    })
  })
});

export const { useListRepositoryUsersQuery, useGetNotaryAuditLogQuery } =
  notariesApi;
